import React from 'react'
import classNames from 'classnames'
import { AutoFollowChatMessageContainer } from '@/molecules/AutoFollowChatMessageContainer'
import { TheatricalReleaseResult } from '@/services/Theatrical'
import useContainerSize from '@/utils/useContainerSize'

interface HypebotProps {
  isOneLineMessages?: boolean
  hideScrollbar?: boolean
  className?: string
  isNewDesign?: boolean
  initialMessageClassName?: string
  theatricalRelease?: TheatricalReleaseResult
}

export const Hypebot: React.FC<HypebotProps> = ({
  className,
  isOneLineMessages,
  hideScrollbar,
  isNewDesign = false,
  initialMessageClassName,
  theatricalRelease,
}) => {
  const [containerRef, containerSize] = useContainerSize<HTMLDivElement>()

  const shouldHide = containerSize.height > 0 && containerSize.height < 80

  return (
    <div
      ref={containerRef}
      className={classNames(
        'flex flex-col justify-between pb-3 shadow-xl rounded-b-2xl overflow-hidden w-full min-w-52 h-full bg-core-gray-950 relative shrink grow-1 min-h-0 transition-all duration-200',
        className,
        { invisible: shouldHide },
      )}
    >
      <AutoFollowChatMessageContainer
        initialMessageClassName={initialMessageClassName}
        isNewDesign={isNewDesign}
        isOneLineMessages={isOneLineMessages}
        hideScrollbar={hideScrollbar}
        theatricalRelease={theatricalRelease}
      />
    </div>
  )
}
